'use client';

import { useEffect } from 'react';
import { canUseDOM } from '@/app/common/utils/canUseDOM';
import { getScrollbarWidth } from '@/utils/domUtils.ts';

/**
 * Custom hook that computes scrollbar width once and sets it as a CSS variable.
 * This allows CSS to handle padding adjustments when modals are open.
 */
export default function useInitialScrollbarWidth() {
  useEffect(() => {
    if (!canUseDOM) return;

    const scrollBarWidth = getScrollbarWidth() || 0;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
  }, []);
}
